const bugReportPageTranslations = {
  breadCrumbs: {
    heading: "Bug report",
    links: {
      1: "Home",
      2: "Bug report",
    },
  },
  title: "Bug report",
  description: `We strive to make our application as flawless as possible, but
    sometimes bugs slip through the cracks. If you've encountered
    an issue, we're here to help! Please use the form below to
    report any bugs or issues you've experienced. Your feedback is
    invaluable in helping us improve.`,
  cta: "Need More Help ?",
};

export default bugReportPageTranslations;
